import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'
import { Tooltip } from '@/components/ui/tooltip'
import { EMPTY_VALUE } from '@/constants/ui'

import { getAccessTypeBadges } from './access-type-cell.constants'
import * as S from './access-type-cell.styled'

export type AccessTypeCellProps = {
  pinCode?: boolean
  keyAccess?: boolean
  keylessAccess?: boolean
  customAccess?: boolean
  customAccessName?: string
}

export const AccessTypeCell = (props: AccessTypeCellProps) => {
  const { t } = useTranslation(['visitors'])
  const badges = useMemo(() => getAccessTypeBadges(t), [t])
  const enabledBadges = badges.filter((badge) => props[badge.field])

  if (enabledBadges.length === 0) return EMPTY_VALUE

  return (
    <S.Wrapper>
      {enabledBadges.map(({ color, field, icon, id, tooltip }) => (
        <Tooltip
          key={id}
          trigger={
            <S.Badge $bgColor={color}>
              <Icon icon={icon} color="white" size="1.6rem" />
            </S.Badge>
          }
        >
          {field === 'customAccess' ? props.customAccessName || tooltip : tooltip}
        </Tooltip>
      ))}
    </S.Wrapper>
  )
}
